<div class="view-page" id="view-page">
    <div class="container">
        <mm-spinner [loading]="viewPageComponentState$" [makeInert]="false"></mm-spinner>
        <mm-banners *ngIf="hasViewPageServiceError" [serviceError]="(viewPageServiceError$ | async)!"
            [type]="'error'"></mm-banners>
        <mm-cancel-link-modal [showModal$]="cancelButtonClickedAsObservable$" [id]="'cancel-button-modal'"></mm-cancel-link-modal>
        <delete-standing-auth-modal [showModal$]="deleteButtonClickedAsObservable$" [currentTransaction$]="currentSelectedTransactionAsObservable$"></delete-standing-auth-modal>
        <mm-delete-template-modal [showModal$]="deleteTemplateLinkClickedAsObservable$" [currentTemplate$]="currentSelectedTemplateAsObservable$"></mm-delete-template-modal>
        <a (click)="downloadPdf()" id="download-pdf-link"><i class="sch-download"></i>PDF</a>
        <div class="print-content" id="print-view-page">
            <img id="print-logo" src="./static/assets/images/cs_logo-04.png" width="100" height="100">
            <span id="view-page-header" class="section-title">
              {{pageTitle}}
            </span>
            <div class="view-wire-status-unavailable-warning-banner">
                <mm-banners *ngIf="showWireEAuthStatusUnavailableWarning" class="sdps-messaging--warning" [type]="'warning'" data-testid="viewWireWarning-banner" [bannerText]="[wireRetryWarningBannerText]">
                </mm-banners>
            </div>
            <mm-view-details
                *ngIf="!isTemplateView"
                [viewDetails$]="viewDetails$"
                [pendReasons$]="pendReasons$"
                [useCondensedLayout]="!useOriginalLayout">
            </mm-view-details>
            <mm-transaction-review-check
                *ngIf="isCheckTransaction && !useOriginalLayout"
                data-testid="transaction-view-check-component">
            </mm-transaction-review-check>
            <mm-transaction-review-ach
                *ngIf="isAchTransaction && !useOriginalLayout"
                data-testid="transaction-condensed-view-page">
            </mm-transaction-review-ach>
            <mm-transaction-review-it
                *ngIf="useCondensedLayoutForIt"
                data-testid="transaction-view-it-condensed">
            </mm-transaction-review-it>
            <mm-transaction-review id="transaction-view-page" *ngIf="useOriginalLayout"
                [transactionType]="(transactionType$ | async)!" [isTemplateView]="isTemplateView" data-testid="transaction-view-page">
            </mm-transaction-review>
            <mm-condensed-eauth-section *ngIf="!useOriginalLayout && showClientAuthorizationDetails" [customerList]="custAcctAuthorizations"></mm-condensed-eauth-section>
            <sdps-divider *ngIf="!useOriginalLayout" class="condensed-divider" variation="primary"></sdps-divider>
        </div>
        <button id="viewPage_startTransactionButton" type="button" *ngIf="isTemplateView && !hasHeaderStateServiceError" (click)="onStartTransactionClicked()" data-testid="start-transaction-button"
            class="sdps-button sdps-button--small sdps-button--secondary">Create transaction</button>
        <button id="viewPage_backButton" type="button" (click)="onBackClicked()" data-testid="back-button"
            class="sdps-button sdps-button--small sdps-button--secondary">Back</button>
        <button id="viewPage_editTransactionButton" type="button" *ngIf="editTransactionButtonVisible && !isInRFirm"
            data-testid="viewEditTransaction-button" (click)="onEditTransactionButtonClicked()"
            class="sdps-button sdps-button--small sdps-button--secondary">Edit</button>
        <button id="viewPage_cancelTransactionButton" type="button" *ngIf="cancelTransactionButtonVisible && !isStandingAuth"
            data-testid="viewCancelTransaction-button" (click)="onCancelTransactionButtonClicked()"
            class="sdps-button sdps-button--small sdps-button--secondary">Cancel transaction</button>
        <button id="viewPage_deleteTransactionButton" type="button" *ngIf="(cancelTransactionButtonVisible && isStandingAuth) || isTemplateView"
            data-testid="viewDeleteTransaction-button" (click)="onDeleteClicked()"
            class="sdps-button sdps-button--small sdps-button--secondary">Delete</button>
        <button id="viewPage_viewAuthFormButton" type="button" *ngIf="showViewLoaButton"
            data-testid="viewAuthForm-button" (click)="onViewAuthFormClicked()"
            class="sdps-button sdps-button--small sdps-button--secondary">View Authorization form</button>
    </div>
    <mm-editing-restricted-modal></mm-editing-restricted-modal>
</div>
